// extracted by mini-css-extract-plugin
export default {"tableWrapper":"imports_history_table-module___tableWrapper___ed05b939"};